import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-open_with_faire_application_submit-submit';
/**
 * Event that triggers on open with faire application submitted. Sent to Facebook through Pixel and CAPI.
 */
export function trackOpenWithFaireOpenWithFaireApplicationSubmitSubmit(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'OwFApplication',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
